import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Helper } from '../common/helper';
import { OnlineOfflineService } from '../../services/online-offline.service';
import { ToastrService } from 'ngx-toastr';
import { DbContextService } from '../../services/db-context.service';
import { UserNotificationData } from '../notification/Model/user-notification';
import { OfflineQueueService } from '../../services/offline-queue.service';
import { Observable, catchError, throwError } from 'rxjs';
import { SecurityHelper } from '../common/securityHelper';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(
    private http: HttpClient,
    private readonly offlineQueueService: OfflineQueueService,
    private readonly onlineOfflineService: OnlineOfflineService,
    public dbStore: DbContextService,
    private toastr: ToastrService) { }

  logIn(username: string, password: string) {
    if (!this.onlineOfflineService.isOnline) {
      //  this.addToIndexedDb(order);
      this.toastr.toastrConfig.positionClass = 'toast-top-center';
      // this.toastr.toastrConfig.toastClass = 'toast-info';
      this.toastr.success("You are currently working offline. you transaction will be confirmed once you get an internet connection", "Application Offline", { timeOut: 18000 });
    }
    if (this.onlineOfflineService.isOnline) {
      let param = {
        username: username,
        password: password
      }
      return this.http.post(Helper.API_URL() + '/api/General/LogInOWS', param);
    }
  }

  logInAsImpersonatedUser(userID: number) {

    const paramObject = {
      'userID': userID,
    }

    return this.http.post(Helper.API_URL() + '/api/Security/LogInAsImpersonatedUser', paramObject);
  }

  logOut() {

    return this.http.post(Helper.API_URL() + '/api/Security/Logout', {});
  }

  allowImpersonate() {

    return this.http.post(Helper.API_URL() + '/api/Security/AllowImpersonate', {});
  }

  initialize(): Observable<any> {

    const paramObject = {
      'application': Helper.APPLICATION_SHORT_NAME,
    }

    return this.http.post(Helper.API_URL() + '/api/General/Initialize', paramObject);
  }

  refreshToken(): Observable<any> {
    const paramObject = {
      'userID': SecurityHelper.GetLoggedInUserData().userID,
      'application': Helper.APPLICATION_SHORT_NAME,
    }
    return this.http.post(Helper.API_URL() + '/api/General/RefreshToken', paramObject).pipe(
      catchError((error: any) => {
        return throwError(() => error);
      })
    );
  }

  verifyCatpcha(data: any) {
    return this.http.post('https://www.google.com/recaptcha/api/siteverify', data);
  }

  // move to security service
  getUserNotificationList(userID: number) {

    return this.http.post(Helper.API_URL() + '/api/Security/GetUserNotificationList', {});
  }

  // move to security service
  deleteUserNotification(data: any) {
    return this.http.post(Helper.API_URL() + '/api/Security/DeleteUserNotification', data);
  }

  getActiveShipCrewByShipAndCrewSubType(crewSubTypeID: number) {

    // convert to httpPost
    let paramObject = {
      'crewSubTypeID': crewSubTypeID,
    }

    return this.http.post(Helper.API_URL() + '/api/Maintenance/GetActiveShipCrewByShipAndCrewSubType', paramObject);
  }

  getShipsIDNameList() {
    return this.http.post(Helper.API_URL() + '/api/Maintenance/GetShipsIDNameList', {});
  }

  handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(() => errorMessage);
  }

  // Index DB -------------------------------------------------------------------

  getUserNotificationIndexDb(): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      let notifList: UserNotificationData[] = [];
      this.dbStore.openDatabase().then(db => {
        const tx = db.transaction('OWS_tblNotification', 'readwrite');
        let store = tx.objectStore('OWS_tblNotification');
        store.getAll().then((res: UserNotificationData[]) => {
          res.forEach((notif: UserNotificationData) => {
            notifList.push(notif);
          })
          resolve(notifList);
        })
      });
    });
    return promise;
  }

  saveUserNotificationIndexDb(notifList: UserNotificationData[]) {
    this.dbStore.openDatabase().then(db => {
      const tx = db.transaction('OWS_tblNotification', 'readwrite');
      let store = tx.objectStore('OWS_tblNotification');
      store.clear();
      //clear notif list with valid id or prev notifs pulled from ifsobs
      notifList.forEach((notif: UserNotificationData) => {
        let req = store.add(notif);
      });
    });
  }

  deleteUserNotificationIndexDb(notification: UserNotificationData) {
    this.dbStore.openDatabase().then(db => {
      const tx = db.transaction('OWS_tblNotification', 'readwrite');
      let store = tx.objectStore('OWS_tblNotification');
      let req = store.delete(notification.notificationID);
    });
  }

  markDeleteUserNotificationIndexDb(notification: UserNotificationData) {
    //add to queue
    this.offlineQueueService.pushQueueIndxdb('/api/Security/DeleteUserNotification', notification,
      this.onlineOfflineService.isAuthenticated, Helper.Constants.RequestModules.NOTIFICATION_LIST, notification.notificationID, null);
  }

  getUserShipsList(userID: any) {
    if (!this.onlineOfflineService.isOnline) {
      //  this.addToIndexedDb(order);
      this.toastr.success("User ship list get from local indexedbd", "Application Offline", { timeOut: 8000 });
    }
    if (this.onlineOfflineService.isOnline) {

      return this.http.post(Helper.API_URL() + '/api/security/GetUserShipsList', {});
    }
  }

  getPrivacyPolicyURL() {
    return this.http.get(Helper.API_URL() + '/api/General/GetPrivacyPolicyURL');
  }
}
